import React from 'react';
import './YouTubeMarketing.css';
import youtubeImage from '../assets/youtbe.png';

const YouTubeMarketing = () => {
  return (
    <section className="youtube-marketing-section">
      <div className="container youtube-marketing-content">
        <div className="youtube-marketing-text">
          <h5>YOUTUBE MARKETING</h5>
          <h2>Grow Your Brand with YouTube Marketing</h2>
          <p>
            YouTube is the second largest search engine. With the right strategy, you can connect with your audience, build trust, and drive conversions through video content that educates and entertains.
          </p>
          <ul>
            <li>✔ Reach billions through engaging videos</li>
            <li>✔ Optimize your channel for discovery</li>
            <li>✔ Track real-time performance analytics</li>
          </ul>
          <button className="get-started-btn">Get Started</button>
        </div>
        <div className="youtube-marketing-image-container">
          <img src={youtubeImage} alt="YouTube Marketing" />
        </div>
      </div>
    </section>
  );
};

export default YouTubeMarketing;
